module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_006.png
// module id = 2322
// module chunks = 5